import { render } from "./AuditTrailIndex.vue?vue&type=template&id=3ce421a6&scoped=true"
import script from "./AuditTrailIndex.vue?vue&type=script&lang=js"
export * from "./AuditTrailIndex.vue?vue&type=script&lang=js"

import "./AuditTrailIndex.vue?vue&type=style&index=0&id=3ce421a6&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\vrs_yii2_new\\vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce421a6"]])

export default __exports__